import request from '@/utils/request'


//获取所有往来单位类型
export function getCompanyType(params) {
  return request({
    url: '/kxuser/user/getCompanyType',
    method: 'get',
    params: params
  })
}

//企业购买类型
export function getCompanyBuyType(params) {
  return request({
    url: '/kxuser/new_role/getCompanyType1/seller_type',
    method: 'get',
    params: params
  })
}

//查看所有往来单位
export function fetchList(params) {
  return request({
    url:'/kxuser/userAdmin/selectCompany',
    method:'get',
    params:params
  })
}


// 商家企业信息列表
export function getMerchantEnterprise(params) {
  return request({
    url:'/kxuser/userAdmin/getMerchantEnterprise',
    method:'get',
    params:params
  })
}


//创建厂家
export function createFactory(data) {
  return request({
    url: '/kxuser/userAdmin/newFactory',
    method: 'post',
    data: data
  })
}

//厂家列表
export function fetchcompanylist(params) {
  return request({
    url:'/kxuser/userAdmin/searchCompany',
    method:'get',
    params:params
  })
}

//根据当前用户ID查看往来单位
export function userCompanyid(id ,params) {
  return request({
    url: '/kxuser/user/company/'+id,
    method: 'get',
    params : params
  })
}

//绑定往来单位
export function createcompany(data) {
  return request({
    url: '/kxuser/user/create/company',
    method: 'post',
    data: data
  })
}

//新建企业
export function createCompanyInfo(data) {
  return request({
    url: '/kxuser/user/createCompanyInfo',
    method: 'post',
    data: data
  })
}

export function updatecompany(data) {
  return request({
    url: '/kxuser/user/update/company/',
    method: 'post',
    data: data
  })
}

export function updateStatus(id, params) {
  return request({
    url: '/kxuser/userAdmin/updateStatus/' + id,
    method: 'post',
    params: params
  })
}


export function deletecompany(id) {
  return request({
    url: '/kxuser/user/delete/' + id,
    method: 'post'
  })
}



//往来单位资金明细
export function accountList(params) {
  return request({
    url:'/kxuser/account/list/',
    method:'get',
    params:params
  })
}

//往来单位充值
export function refundRecharge(data) {
  return request({
    url: '/kxuser/account/refundRecharge/',
    method: 'post',
    data:data
  })
}


//财务审核资金
export function refundAccountAudit(data) {
  return request({
    url: '/kxuser/account/AccountAudit/',
    method: 'post',
    data:data
  })
}

//当前往来单位金额统计
export function SumAccountMoney(params) {
  return request({
    url: '/kxuser/account/SumAccountMoney/',
    method: 'get',
    params:params
  })
}


//查看所有厂家
export function getCertificateByGoods(params) {
  return request({
    url:'/kxuser/user/getCertificateByGoodsId',
    method:'get',
    params:params
  })
}

//根据厂家ID查看资质
export function getCertificateByGoodsId(params) {
  return request({
    url: '/kxuser/user/getCertificateByGoodsId/',
    method: 'get',
    params : params
  })
}


//批量上传资质
export function bulkUpload(data) {
  return request({
    url: '/kxuser/user/bulkUpload/company/',
    //url:'/kxuser/user/uploadUserAvatar/company/',
    method: 'post',
    data: data,
    headers: {
      "Content-Type": "multipart/form-data;charset=utf-8"
    },
  })
}


//资质上传
export function uploadImg(data) {
  return request({
    url: '/kxuser/user/uploadUserAvatar/company',
    method: 'post',
    data: data,
    headers: {
      "Content-Type": "multipart/form-data;charset=utf-8"
    },
  })
}

//添加资质
export function manufacturer(data) {
  return request({
    url: '/kxuser/user/manufacturer',
    method: 'post',
    data: data
  })
}

//修改资质
export function updatecertificate(id, data) {
  return request({
    url: '/kxuser/user/update/certificate/' + id,
    method: 'post',
    data: data
  })
}



//用户绑定客服
export function bdkf(data) {
  return request({
    url: '/kxuser/userAdmin/bdkf',
    method: 'post',
    data: data
  })
}

//获取客服列表
export function kfList(params){
  return request({
    url: '/kxuser/userAdmin/hqkf',
    method: 'get',
    params: params
  })
}


//查看所有充值类别
export function querySellType(params) {
  return request({
    url: '/kxuser/new_role/getCompanyType1/recharge_type',
    method: 'get',
    params: params
  })
}


//用户标签
export function companyTags(data) {
  return request({
    url: '/kxuser/userAdmin/userLabel',
    method: 'post',
    data: data
  })
}


//获取用户类别
export function getUserlabel(params) {
  return request({
    url: '/kxuser/new_role/getCompanyType1/user_label',
    method: 'get',
    params: params
  })
}


//修厂家权重
export function updategoodsprom(data) {
  return request({
    url: '/kxuser/user/update/mfrs',
    method: 'post',
    data: data
  })
}


//待审核资金明细
export function getCompanyAccRecInfoList(params) {
  return request({
    url:'/kxuser/account/getCompanyAccRecInfoList',
    method:'get',
    params:params
  })
}

//ES查询单位
export function queryCompanyInfo(params) {
  return request({
    url:'/kxes/esCompany/queryCompanyInfo',
    method:'get',
    params:params
  })
}


// WEBPACK FOOTER //
// ./src/api/company.js